import Vue from 'vue'
import router from '@/router/index.js'

import '@/plugins/axios.js'
import '@/plugins/helpers.js'
import '@/plugins/keycloakplugin.js'

import moment from 'moment'
import 'moment/locale/es'

import VueTooltip from 'v-tooltip'
import VueTheMask from 'vue-the-mask'
import VueSweetalert from 'vue-sweetalert2'
import FlagIcon from 'vue-flag-icon'
import VueMoment from 'vue-moment'
import VueCurrencyFilter from 'vue-currency-filter'
import Money, { VMoney } from 'v-money'
import VueGtag from 'vue-gtag'
import ElementUI from 'element-ui'
import { ElementTiptapPlugin } from 'element-tiptap'
import 'element-tiptap/lib/index.css'

let IDAnalytics = ''

if (process.env.VUE_APP_ID_ANALYTICS === 'beaware360') {
  IDAnalytics = 'G-HFV0SFJMRD'
} else if (process.env.VUE_APP_ID_ANALYTICS === 'beaware') {
  IDAnalytics = 'G-Q2TE0JL4MH'
}

Vue.use(VueGtag, {
  config: { id: IDAnalytics }
}, router)

Vue.use(VueTooltip)
Vue.use(VueTheMask)
Vue.use(VueSweetalert)
Vue.use(FlagIcon)
Vue.use(VueMoment, { moment })
// use ElementUI's plugin
Vue.use(ElementUI)
// use this package's plugin
Vue.use(ElementTiptapPlugin, {
  lang: 'es', // see i18n
  spellcheck: false // can be overwritten by editor prop
})
Vue.use(VueCurrencyFilter, { symbol: '', thousandsSeparator: '.', fractionCount: 2, fractionSeparator: ',', symbolPosition: 'front', symbolSpacing: false })
Vue.use(Money, { decimal: ',', thousands: '.', prefix: '', suffix: '', precision: 2, masked: false })
Vue.directive('money', VMoney)
